var chunkMapping = {
	"122": [
		28122
	],
	"310": [
		63310
	]
};
var idToExternalAndNameMapping = {
	"28122": [
		"default",
		"./ShellAppHeader",
		92019
	],
	"63310": [
		"default",
		"./GlobalFooter",
		92019
	]
};
var idToRemoteMap = {
	"28122": [
		{
			"externalType": "script",
			"name": "web_mfe_shell",
			"externalModuleId": 92019
		}
	],
	"63310": [
		{
			"externalType": "script",
			"name": "web_mfe_shell",
			"externalModuleId": 92019
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}